import React, { useRef, useEffect } from "react";
import TinySlider from "tiny-slider-react";
import "tiny-slider/dist/tiny-slider.css";

function Slider({ items, teasers, labels }) {
  const sliderRef = useRef(null);
  const controlsRef = useRef(null);

  const settings = {
    nav: false,
    autoplay: false,
    gutter: 20,
    axis: "horizontal",
    controls: true,

    controlsText: ["", ""],
    controlsPosition: "bottom",
    responsive: {
      1024: {
        items: 2,
      },
      1025: {
        items: 3,
      },
    },
    loop: false,
    fixWidth: true,
  };

  return (
    <div className="v-mx-5">
      <TinySlider settings={settings} ref={sliderRef}>
        {items.length > 0 ? (
          items.map((entity, index) => {
            return (
              teasers[entity.nid] && (
                <div
                  key={index}
                  className={index % 2 ? "" : ""}
                  dangerouslySetInnerHTML={{
                    __html: teasers[entity.nid],
                  }}
                />
              )
            );
          })
        ) : (
          <div className={"no-results v-p-4 v-transition-none"}>
            {labels["nothing"]}
          </div>
        )}
      </TinySlider>
    </div>
  );
}

export default Slider;
